<style src="./style.scss">
</style>

<script lang="ts">
  import { navigate } from "svelte-navigator";

  import Button from "@components/button";
  import Header from "@components/header";
  import Footer from "@components/footer";
  import Icon from "svelte-icon";

  import IconIos from "@assets/images/icon-ios.png";
  import Confetti from "@assets/images/confetti.png";
  import AppStore from "@assets/images/appstore.svg";
  import GooglePlay from "@assets/images/googleplay.svg";

  function whatsappLink() {
    window.open("https://api.whatsapp.com/send?phone=5511953259744", "_blank");
  }
</script>

<Header steps="{[1, 2, 3]}" activeStep="{1}" checkedStep="{2}" />

<div class="checkout-success">
  <div class="checkout-success__container">
    <div class="checkout-success__content">
      <h1>Parabéns! Tudo certo 🎉</h1>

      <div class="app-icon">
        <img src="{IconIos}" alt="" />
      </div>

      <h2>Baixar agora o app</h2>
      <p>
        Comece a explorar um novo jeito de aprender inglês online, melhor e mais
        rápido.
      </p>

      <div class="stores">
        <a
          href="https://apps.apple.com/br/app/cna-go/id1529651631"
          target="_blank">
          <Icon data="{AppStore}" stroke="transparent" fill="transparent" />
        </a>
        <a
          href="https://play.google.com/store/apps/details?id=br.com.cnago.app"
          target="_blank">
          <Icon data="{GooglePlay}" stroke="transparent" fill="transparent" />
        </a>
      </div>
    </div>

    <div class="checkout-success__content">
      <h2>Estamos aqui para te ajudar!</h2>
      <h3>Entenda o curso</h3>

      <p>
        Um ambiente dedicado para você sanar suas principais dúvidas, entender
        detalhes dos serviços oferecidos pelo CNA Go e curiosidades do
        funcionamento do aplicativo.
      </p>

      <a href="https://help.cnago.com.br/" target="_blank">Acessar</a>

      <div class="divisor"></div>

      <h3>Fale conosco</h3>

      <p>
        Precisa de ajuda?<br /><a href="mailto:hello@cnago.com.br"
          >hello@cnago.com.br</a>
      </p>

      <Button title="Atendimento via WhatsApp" onClick="{whatsappLink}" />
      <div class="checkout-success__info">
        <span
          >Atendimento de segunda-feira a sexta-feira das 09:00 às 18:00.</span>
      </div>
    </div>
  </div>

  <div class="desktop-only">
    <Footer />
  </div>
</div>
